import { useLoadLinksEffect, useSelectors } from 'app/area/links-section/hooks';
import { LinksGroups } from 'app/area/links-section/links-groups';
import { SpinLoader } from 'app/components';
import * as React from 'react';

export function LinksSection() {

  const { linksGroups, fetchingLinks } = useSelectors();

  useLoadLinksEffect();

  if (!linksGroups || linksGroups.length === 0) {
    return null;
  }

  return (
    !fetchingLinks &&
    <LinksGroups
      linksGroups={linksGroups}
    />
  ) || <SpinLoader />;
}
